<template>
  <section class="section">
    <div class="columns">
      <div class="column">
        <box>
          <div slot="header">
            <div class="columns is-vcentered">
              <div class="column">
                <div class="is-flex" style="align-items: center">
                  <div class="is-flex" style="align-items: center">
                    {{ $l("components.agents.agents", "Agents") }}
                  </div>
                  <v-select v-model="showDisabledAgents" class="has-text-weight-normal"
                    style="width: 13.5rem; margin-left: 0.5rem" :options="[
                      {
                        label: $l('components.agents.active', 'Active'),
                        value: false,
                      },
                      {
                        label: $l('components.agents.disabled', 'Disabled'),
                        value: true,
                      },
                    ]" :reduce="(option) => option.value" :clearable="false" />
                  <a class="ml-1" @click.prevent="showSetting">
                    <octicon :icon="gear" :scale="1.3" />
                  </a>
                </div>
              </div>
              <div class="column is-narrow">
                <button v-if="selectedGroup.computedAgentMacs &&
                      selectedGroup.computedAgentMacs.length
                      " class="button is-primary is-small" @click.prevent="showCommandGroup">
                  {{ $l("components.agents.command", "Command") }}
                </button>

                <button v-if="!$route.path.match(/\/agent\/(.*)/)" class="button is-primary is-small"
                  @click.prevent="showCommandAgents">
                  {{ $l("components.agents.command", "Command") }}
                </button>
              </div>
            </div>
          </div>
          <div>
            <div v-if="showDisabledAgents" class="ml-1 mb-2 is-italic">
              <span v-if="setting &&
                      setting.agentSetting &&
                      setting.agentSetting.activeTimeout > 0
                      ">
                {{
                      $t("components.agents.disabledDesc", {
                        days: setting.agentSetting.activeTimeout,
                      })
                    }}
              </span>
              <span v-else>
                {{
                        $l(
                          "components.agents.timeoutEnableDesc",
                          "To enable this feature, set the timeout value first."
                        )
                      }}
              </span>
            </div>
            <data-table ref="agentsTable" :key="currentLocale" :items="agentListFunc" :per-page="10" :sort-desc="true"
              sort-by="status" :theme="$_ui_theme_tables">
              <data-column :label="$l('components.agents.status', 'Status')" field="status" width="10%">
                <template slot-scope="props">
                  <div style="text-align: center" @mouseenter="showComputerStatus(true, props.item, $event)"
                    @mouseleave="showComputerStatus(false, props.item, $event)">
                    <div style="position: relative; display: inline-block">
                      <img v-if="props.item &&
                      props.item.profile &&
                      props.item.profile.quarantine &&
                      props.item.profile.quarantine.status
                      " src="@/assets/block.svg" style="width: 15px" class="quarantine-icon" />

                      <svg xmlns="http://www.w3.org/2000/svg" style="width: 30px; height: 30px" viewBox="0 0 16 16">
                        <path fill="#868f99" d="M6.5 11.5H9.5V14.5H6.5z" />
                        <path fill="#868f99" d="M9,12v2H7V12H9m1-1H6v4h4V11Z" />
                        <path v-if="showDisabledAgents" fill="#c2cad4" d="M0.5 1.5H15.5V12.5H0.5z" />
                        <path v-else-if="props.item.status === 2" fill="#5CFD5C" d="M0.5 1.5H15.5V12.5H0.5z" />
                        <path v-else-if="props.item.status === 1" fill="#FFFF00" d="M0.5 1.5H15.5V12.5H0.5z" />
                        <path v-else fill="#FFFFFF" d="M0.5 1.5H15.5V12.5H0.5z" />
                        <path fill="#868f99" d="M15,2V12H1V2H15m1-1H0V13H16V1Z" />
                        <path fill="#868f99"
                          d="M0 11H16V13H0zM4.94 14h6.13a1 1 0 0 1 1 1v0a0 0 0 0 1 0 0H3.94a0 0 0 0 1 0 0v0a1 1 0 0 1 1-1z" />
                        <path fill="#868f99" d="M13 11H14V12H13z" />
                      </svg>
                    </div>
                  </div>
                </template>
              </data-column>
              <data-column field="computerName" :label="$l('components.agents.computerName', 'Computer Name')">
                <template slot-scope="props">
                  <div>
                    {{ props.item.computerName }}
                  </div>
                </template>
              </data-column>
              <data-column field="groupName" :label="$l('components.agents.group', 'Group')">
                <template slot-scope="props">
                  <!-- <a :href="'#/agents/' + props.item.groupID">{{ props.item.groupName }}</a> -->
                  <div>{{ props.item.groupName }}</div>
                </template>
              </data-column>
              <data-column field="ip" :label="$l('components.agents.ip', 'IP')" />
              <data-column field="agentIP" :label="$l('components.agents.agentIP', 'Agent IP')" />
              <data-column field="os" :label="$l('components.agents.operatingSystem', 'Operating System')
                      " />
              <data-column field="version" :label="$l('components.agents.agentVersion', 'Agent Version')">
                <template slot-scope="props">
                  <div>
                    <span v-if="props.item.uninstalled" class="tag is-danger">
                      {{ $l("components.agents.removed", "Removed") }}
                    </span>
                    <span v-else-if="checkOutdatedAgent(props.item)" class="tag is-danger">
                      {{ props.item.version }}
                    </span>
                    <span v-else class="tag">
                      {{ props.item.version }}
                    </span>
                  </div>
                </template>
              </data-column>
              <data-column field="contact" :label="$l('components.agents.description', 'Description')">
                <template slot-scope="props">
                  <pre>{{ props.item.contact }}</pre>
                </template>
              </data-column>
              <data-column :sortable="false" :label="$l('components.agents.action', 'Action')">
                <template slot-scope="props">
                  <div>
                    <button class="button is-info mx-1 my-1 is-small is-light"
                      @click.prevent="showQuickView(props.item, $event)">
                      {{ $l("global.quickView", "Quick View") }}
                    </button>
                    <button class="button is-primary mx-1 my-1 is-small is-light" @click.prevent="showEdit(props)">
                      {{ $l("global.edit", "Edit") }}
                    </button>
                    <button class="button is-primary mx-1 my-1 is-small is-light" @click.prevent="showCommand(props)">
                      {{ $l("components.agents.command", "Command") }}
                    </button>
                    <button class="button is-info mx-1 my-1 is-small is-light" @click.prevent="showDetail(props)">
                      {{ $l("global.detail", "Detail") }}
                    </button>
                    <button class="button is-danger mx-1 my-1 is-small is-light" @click.prevent="deleteAgent(props)">
                      {{ $l("global.delete", "Delete") }}
                    </button>
                  </div>
                </template>
              </data-column>
            </data-table>

            <transition name="fade">
              <box v-show="showFloatBox" ref="floatBoxDetail" class="float-box" :style="{ ...floatBox, width: '30%' }">
                <div v-if="detailAgent.computerName" slot="header">
                  <div class="columns is-vcentered">
                    <div class="column">
                      {{ detailAgent.computerName }}
                    </div>
                    <div class="column is-narrow">
                      <button class="button is-danger is-light is-small" @click.prevent="showFloatBox = false">
                        <octicon :icon="x" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.ip", "IP")
                    }}</label>
                    <span>{{ detailAgent.agentIP }}</span>
                  </div>
                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.localIP", "Local IP")
                    }}</label>
                    <span>{{ detailAgent.ip }}</span>
                  </div>

                  <div class="column is-6">
                    <label class="label">{{
                      $l(
                        "components.agents.operatingSystem",
                        "Operating System"
                      )
                    }}</label>
                    <span>{{ detailAgent.os }}</span>
                  </div>
                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.agentVersion", "Agent Version")
                    }}</label>
                    <span v-if="detailAgent.uninstalled" class="tag is-danger">
                      {{ $l("components.agents.removed", "Removed") }}
                    </span>
                    <span v-else-if="checkOutdatedAgent(detailAgent)" class="tag is-danger">
                      {{ detailAgent.version }}
                    </span>
                    <span v-else>
                      {{ detailAgent.version }}
                    </span>
                  </div>

                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.installTime", "Install Time")
                    }}</label>
                    <span>{{ formatDate(detailAgent.timeInstall) }}</span>
                  </div>
                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.lastConnection", "Last Connection")
                    }}</label>
                    <span>{{ formatDate(detailAgent.lastConnection) }}</span>
                  </div>

                  <div class="column is-6">
                    <label class="label">{{
                      $l("components.agents.contact", "Contact")
                    }}</label>
                    <div>
                      {{
                        (detailAgent.contact
                          ? detailAgent.contact
                          : "&nbsp;") || "&nbsp;"
                      }}
                    </div>
                  </div>
                </div>
              </box>
            </transition>

            <box ref="boxComputerStatus" class="computer__status-box" :style="{ ...floatBoxStatus }">
              <div>
                <span v-if="computerStatus === 2">Online</span>
                <span v-else-if="computerStatus === 1">Waiting</span>
                <span v-else>Offline</span>
              </div>
            </box>
          </div>
        </box>
      </div>
    </div>

    <modal :show.sync="showEditModal">
      <box>
        <div slot="header">
          {{ $l("components.agents.agentDetail", "Agent Detail") }}
        </div>
        <tabs :theme="$_ui_theme_tabs">
          <tab :title="$l('components.agents.group', 'Group')">
            <div class="control">
              <v-select v-model="detailAgentGroup" multiple append-to-body label="name"
                :options="groupOptions.filter((e) => e._id)" @option:selected="handleSelectedAgentGroup" />
            </div>
          </tab>
        </tabs>

        <div slot="footer" class="field is-grouped is-grouped-right">
          <div class="control">
            <button class="button is-info" @click.prevent="updateAgentGroups">
              {{ $l("global.update", "Update") }}
            </button>
          </div>
          <div class="control">
            <button class="button is-primary" @click.prevent="showEditModal = false">
              {{ $l("global.cancel", "Cancel") }}
            </button>
          </div>
        </div>
      </box>
    </modal>

    <modal content-width="80vw" :show.sync="showCommandModal">
      <agent-command :visible.sync="showCommandModal" :audience="commandAudience" :isAllAgents="isAllAgents"
        :isOneAgent="isOneAgent" :license="license" :title="agentCommandTitle" :groupID="groupID"
        @close="showCommandModal = false" />
    </modal>

    <modal :show.sync="showModal">
      <box>
        <div slot="header">
          {{ $l("components.agents.agentDetail", "Agent Detail") }}
        </div>

        <div>
          <tabs :theme="$_ui_theme_tabs">
            <tab :title="$l('global.detail', 'Detail')">
              <agent-detail :detail-agent="detailAgent" :outdated="checkOutdatedAgent(detailAgent)" />
            </tab>
            <tab :title="$l('components.agents.Json', 'Json')">
              <snippet language="json" :code="SanitizeObject(detailAgent)" />
            </tab>
          </tabs>
        </div>
      </box>
    </modal>

    <modal :show.sync="showSettingModal">
      <box v-if="setting">
        <div slot="header">
          {{ $l("components.agents.agentSetting", "Agent Setting") }}
        </div>

        <div style="margin: auto; width: 80%">
          <label class="label">{{ $l("components.agents.activeTimeout", "Active Timeout") }}
          </label>
          <div class="field has-addons">
            <p class="control is-expanded">
              <input v-model.number="setting.agentSetting.activeTimeout" class="input" type="number" />
            </p>
            <p class="control">
              <a class="button is-static">
                {{ $l("components.agents.days", "Days") }}
              </a>
            </p>
          </div>

          <div class="ml-1 mb-1 is-italic">
            {{
                      $l(
                        "components.agents.timeoutDesc",
                        "Agents which had no connection to the server in this timeout will be moved to the non-active section."
                      )
                    }}
          </div>
          <div class="ml-1 mb-2 is-italic">
            {{
                        $l(
                          "components.agents.timeoutDisableDesc",
                          "To disable this feature, set the timout to 0."
                        )
                      }}
          </div>
        </div>

        <div slot="footer" class="field is-grouped is-grouped-right">
          <div class="control">
            <button class="button is-info" @click.prevent="updateSetting">
              {{ $l("global.update", "Update") }}
            </button>
          </div>
          <div class="control">
            <button class="button is-primary" @click.prevent="showSettingModal = false">
              {{ $l("global.cancel", "Cancel") }}
            </button>
          </div>
        </div>
      </box>
    </modal>
  </section>
</template>
<script>
import { DataTable, DataColumn, Modal, Snippet, Tabs, Tab } from "@cyradar/ui";
import { SanitizeObject } from "@/utils";
import vSelect from "vue-select";
import Format from "date-fns/format";
import AddDays from "date-fns/add_days";
import IsAfter from "date-fns/is_after";
import GroupApi from "@/api/Group";
import AgentApi from "@/api/Agent";
import SettingApi from "@/api/Setting";
import { mapGetters } from "vuex";
import AgentDetail from "../components/AgentDetail";
import AgentCommand from "../components/AgentCommand";
import { x, gear } from "octicons-vue";
import { Icon } from "iview";

export default {
  name: "Agents",
  components: {
    DataTable,
    DataColumn,
    Modal,
    Tabs,
    Tab,
    Snippet,
    vSelect,
    AgentDetail,
    AgentCommand,
    Icon,
  },
  data() {
    return {
      SanitizeObject: SanitizeObject,
      showModal: false,
      showEditModal: false,
      showCommandModal: false,
      showSettingModal: false,
      detailAgent: {},
      detailAgentGroup: [],
      selectedGroup: { name: "All", computedAgentMacs: [], _id: "" },
      groupOptions: [],
      listAgentVersion: [],
      showFloatBox: false,
      floatBox: {
        left: 0,
        top: 0,
      },
      commandAudience: [],
      isAllAgents: false,
      isOneAgent: false,
      license: "",
      agentCommandTitle: "",
      groupID: "",
      x,
      gear,
      floatBoxStatus: {
        left: 0,
        top: "100%",
      },
      setting: null,
      computerStatus: "",
      showDisabledAgents: false,
      agentsList: [],
    };
  },
  computed: {
    paramGroupID() {
      let params = this.$route.path.split("/");
      if (!params) {
        return "";
      }

      return params[3] || params[2] || "";
    },
    selectedAgentMacs() {
      if (this.selectedGroup.name === "All" && this.selectedGroup.computedAgentMacs.length === 0) {
        return [""];
      }
      return this.selectedGroup.computedAgentMacs;
    },
    selectedGroupID() {
      if (this.selectedGroup.name === "All") {
        return "";
      }
      return this.selectedGroup._id;
    },
    ...mapGetters(["currentLocale"]),
  },

  watch: {
    showDisabledAgents() {
      this.$refs.agentsTable.loadItems();
    },
    selectedGroup(val, oldVal) {
      this.$refs.agentsTable.loadItems();
    },
    paramGroupID(val) {
      let g = this.groupOptions.find((e) => e._id === val);
      if (g) {
        this.selectedGroup = g;
      }
    },
  },
  mounted() {
    this.fetchGroups().then((groupList) => {
      let g = this.groupOptions.find((e) => e._id === this.paramGroupID);
      if (g) {
        this.selectedGroup = g;
      }
    });
    this.fetchListAgentVersion();
    this.fetchSetting();
  },
  methods: {
    showCommand(props) {
      this.commandAudience = [props.item.mac];
      this.isAllAgents = false;
      this.isOneAgent = true;
      this.license = props.item.groupKey;
      this.agentCommandTitle = props.item.computerName;
      this.showCommandModal = true;
    },
    showCommandGroup() {
      this.commandAudience = this.selectedGroup.computedAgentMacs;
      this.isAllAgents = false;
      this.isOneAgent = false;
      this.license =
        this.agentsList &&
          this.agentsList.length > 0 &&
          this.agentsList[0].groupKey
          ? this.agentsList[0].groupKey
          : "";

      this.agentCommandTitle =
        this.selectedGroup && this.selectedGroup.name
          ? this.selectedGroup.name
          : "";

      this.groupID =
        this.selectedGroup && this.selectedGroup._id
          ? this.selectedGroup._id
          : "";

      this.showCommandModal = true;
    },

    showCommandAgents() {
      this.isAllAgents = true;
      this.isOneAgent = false;
      this.license = "";
      this.agentCommandTitle = "";
      this.showCommandModal = true;
    },

    formatListString(val) {
      if (!val || val.length === 0) {
        return "";
      }
      return val.join(", ");
    },
    formatDate(val) {
      if (!val) {
        return "";
      }
      return Format(val, "YYYY-MM-DD HH:mm");
    },
    checkOutdatedAgent(agent) {
      if (!agent.version) {
        return false;
      }

      for (let i = 0; i < this.listAgentVersion.length; i++) {
        let item = this.listAgentVersion[i];
        if (item.version === agent.version) {
          let currentVerDate = Date.parse(item.publishedAt);
          if (IsAfter(new Date(), AddDays(currentVerDate, 15))) {
            return true;
          }
          return false;
        }
      }
      return false;
    },
    fetchGroups() {
      return GroupApi.getGroupList(this.$http)
        .then((data) => {
          data.map((g) => {
            g.computedAgentMacs = g.agentMacs;
            if (g.childAgentMacs) {
              g.computedAgentMacs = g.computedAgentMacs.concat(
                g.childAgentMacs
              );
            }
            return g;
          });
          return data;
        })
        .then((data) => {
          let listGroup = JSON.parse(JSON.stringify(data));
          listGroup.unshift({ name: "All", agentMacs: [], _id: "" });
          this.groupOptions = listGroup;
          return data;
        });
    },
    fetchListAgentVersion() {
      AgentApi.getListVersion(this.$http).then((data) => {
        this.listAgentVersion = data;
      });
    },
    fetchSetting() {
      return SettingApi.getSetting(this.$http).then((res) => {
        this.setting = res.data;
      });
    },
    agentListFunc(filtering, sorting, paging) {
      // console.log("this.groupID", this.groupID)
      return AgentApi.getAgentVueTable(this.$http, filtering, sorting, paging, {
        // agentMacs: this.selectedAgentMacs,
        disabled: this.showDisabledAgents,
        groupID: this.selectedGroupID,
      }).then((res) => {
        this.agentsList = res.data.items;
        return res.data;
      });
    },
    updateAgentGroups() {
      let payload = {
        actions: "add-groups",
        agentMac: this.detailAgent.mac,
        groups: this.detailAgentGroup.filter((e) => e._id).map((e) => e._id),
      };
      AgentApi.updateAgent(this.$http, payload).then((data) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: data.message,
          duration: 10000,
        });
        this.fetchGroups();
        this.showEditModal = false;
      });
    },
    handleSelectedAgentGroup(selectedOption) {
      this.detailAgentGroup = selectedOption.slice(-1);
    },
    deleteAgent(props) {
      if (!window.confirm(this.$l("global.confirmDelete", "Are you sure?"))) {
        return;
      }

      AgentApi.deleteAgent(this.$http, props.item).then((data) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: data.message,
          duration: 10000,
        });
        this.$refs.agentsTable.loadItems();
      });
    },
    updateSetting() {
      return SettingApi.updateSetting(this.$http, this.setting).then((data) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: data.message,
          duration: 10000,
        });
        this.$refs.agentsTable.loadItems();
        this.showSettingModal = false;
      });
    },
    showEdit(props) {
      this.detailAgent = Object.assign({}, props.item);

      this.detailAgentGroup = this.groupOptions.filter((g) => {
        if (!g.agentMacs || g.agentMacs.length === 0) {
          return false;
        }
        return g.agentMacs.includes(this.detailAgent.mac);
      });
      this.showEditModal = true;
    },
    showDetail(props) {
      this.showModal = true;
      this.detailAgent = Object.assign({}, props.item);
    },
    showQuickView(data, e) {
      if (this.detailAgent._id === data._id && this.showFloatBox === true) {
        this.showFloatBox = false;
        return;
      }

      this.showFloatBox = true;
      this.detailAgent = data;

      const el = e.target.getBoundingClientRect();
      let boxLeft = window.innerWidth - el.x;
      let boxTop = el.y + window.scrollY;

      this.floatBox = {
        right: boxLeft + "px",
        top: boxTop + "px",
      };
    },
    showComputerStatus(val, data, e) {
      const el = e.target.getBoundingClientRect();
      let boxRight = el.right;
      let boxTop = el.top - 5;
      this.floatBoxStatus = {
        left: boxRight + "px",
        top: boxTop + "px",
        opacity: val ? "1" : "0",
      };

      this.computerStatus = data.status;
    },
    showSetting() {
      this.fetchSetting().then((this.showSettingModal = true));
    },
  },
};
</script>

<style src="vue-select/dist/vue-select.css"></style>
<style lang="scss">
.float-box {
  margin: 0;
  position: absolute;
  z-index: 1000;
  overflow: hidden;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

.computer__status-box {
  margin: 0;
  position: fixed;
  opacity: 0;
  overflow: hidden;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
  transition: opacity 0.3s linear;
}

pre {
  padding: 0.5em;
}

.dashboard.is-dark {
  pre {
    background: #40455355;
    color: #f2f2f2;
  }
}

.quarantine-icon {
  position: absolute;
  left: 8px;
  bottom: 15px;
}
</style>
